const TutoStep4 = () => (
  <div className="flex justify-center lg:h-[50vh] lg:w-[60vw]">
    <img src="/tuto/tuto-graphique.svg" className="w-full h-full" alt="tuto" />
  </div>
);

export default TutoStep4;
